import(/* webpackMode: "eager" */ "/home/ubuntu/web.icm.application/app/assets/images/digital-gold.png");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/web.icm.application/app/assets/images/digital-silver.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/web.icm.application/app/components/consultation.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/web.icm.application/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/web.icm.application/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/web.icm.application/app/utils/MetaPixelWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FcmTokenProvider"] */ "/home/ubuntu/web.icm.application/context/fcmcontext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/web.icm.application/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/web.icm.application/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../app/fonts/RedditSans-VariableFont_wght.ttf\",\"display\":\"swap\"}],\"variableName\":\"reddit_sans\"}");
